import { create } from "zustand";

interface DeviceStore {
  safeAreaTop: number | undefined;
  safeAreaBottom: number | undefined;
  setSafeAreaTop: (top: number | undefined) => void;
  setSafeAreaBottom: (bottom: number | undefined) => void;
}

export const useDeviceStore = create<DeviceStore>((set) => ({
  safeAreaTop: undefined,
  safeAreaBottom: undefined,
  setSafeAreaTop: (top) => {
    if (typeof top === "number") {
      set({
        safeAreaTop: top,
      });
    }
  },
  setSafeAreaBottom: (bottom) => {
    if (typeof bottom === "number") {
      set({
        safeAreaBottom: bottom,
      });
    }
  },
}));
